module.exports = __webpack_public_path__ + "static/media/38.692280e8.jpeg";